import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  deleteButton: {
    display: "grid",
    placeItems: "center",
    color: "#1C1B1F",
    backgroundColor: "transparent",
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",

    "&:hover": {
      color: theme.palette.secondary.main,
    },

    "&:disabled": {
      opacity: 0.3,
      cursor: "not-allowed",

      "&:hover": {
        color: theme.palette.secondary.main,
      },
    },
  },
  disabled: {
    opacity: 0.3,
    cursor: "not-allowed",

    "&:hover": {
      color: theme.palette.secondary.main,
    },
  },
}));
